export default __webpack_public_path__ + "static/media/globe_add.3597c849.png";